export function shareByEmail(url: string) {
  const subject = encodeURIComponent("Check out this news article")
  const body = encodeURIComponent(`Here is the link to the news article: ${url}`)
  return `mailto:?subject=${subject}&body=${body}`
}

export function shareOnFacebook(url: string) {
  return `https://www.facebook.com/sharer/sharer.php?u=${url}`
}

export function shareOnLinkedIn(url: string) {
  return `https://www.linkedin.com/sharing/share-offsite/?url=${url}`
}

export function shareOnX(url: string, title?: string) {
  const text = title ? encodeURIComponent(title) : ""
  return `https://twitter.com/intent/post?${title ? "text=" + text : ""}&url=${url}`
}
